/* ==========================================================================
   ENG-7779 — Discovery Kit landing 2026
   Ported behaviour from the reference HTML. Every query is scoped to `.dk-lp`
   and guarded, so the script is a no-op on pages without the landing sections.

   Loaded once (deferred) from layout/theme.liquid, gated by
   template.suffix == 'perfume-discovery-kit-2026'.
   ========================================================================== */
(function () {
  'use strict';

  /* Scroll reveal ---------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.dk-lp .reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* Reviews carousel ------------------------------------------------------- */
  function initReviews() {
    var sections = document.querySelectorAll('.dk-lp--reviews');
    if (!sections.length) return;

    sections.forEach(function (root) {
      var track = root.querySelector('.scroll-track');
      var prevBtn = root.querySelector('.scroll-prev');
      var nextBtn = root.querySelector('.scroll-next');
      if (!track || !prevBtn || !nextBtn) return;

      var scrollAmount = function () {
        var item = track.querySelector('.quote-card');
        return item ? item.offsetWidth + 16 : 320;
      };
      var updateButtons = function () {
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      };

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  /* Sticky mobile CTA — show after the user passes the hero, hide over the
     final CTA ------------------------------------------------------------- */
  function initSticky() {
    var stickyBar = document.querySelector('.dk-lp .sticky-cta-bar');
    var hero = document.querySelector('.dk-lp .hero');
    var finalCta = document.querySelector('.dk-lp .final-cta');
    if (!stickyBar || !hero || !finalCta) return;

    var onScroll = function () {
      var passedHero = window.scrollY > hero.offsetHeight * 0.75;
      var finalCtaInView = finalCta.getBoundingClientRect().top < window.innerHeight * 0.85;
      var show = passedHero && !finalCtaInView;
      stickyBar.classList.toggle('show', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function init() {
    initReveal();
    initReviews();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
